module.exports = __webpack_public_path__ + "static/img/DTU透明倒影.5ce1fe75.png";